import { withTranslation } from "react-i18next";

function Trans({ t, text }) {
  return t(text);
}

export default withTranslation()(Trans);
